import { PositioningPhase } from '@zeus/index'

/** Ce que l'écran lit du positionnement d'un parcours (#321). */
export type PositioningState = {
  myPositioning?: { required: boolean, entryPending: boolean, entryDone: boolean, exitDone: boolean } | null
  progress?: { completed: boolean } | null
}

export type PositioningPhaseView = PositioningPhase

/**
 * Le positionnement à proposer sur l'écran d'un parcours (#321) : l'entrée tant
 * qu'elle ferme les modules, la sortie une fois le parcours terminé si
 * l'apprenant ne s'est pas réévalué. Lu de l'API, jamais recalculé : c'est elle
 * qui décide du verrou (`positioning-gate.ts`).
 */
export function positioningPhase(session: PositioningState): PositioningPhaseView | null {
  const p = session.myPositioning
  if (!p?.required) return null
  if (p.entryPending) return PositioningPhase.ENTRY
  if (session.progress?.completed && !p.exitDone) return PositioningPhase.EXIT
  return null
}
